module.exports = __webpack_public_path__ + "img/WOAC.2b13154c.svg";